import styled from "styled-components"
import {
  desktopTextStyles,
  tabletTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"

export const DataTypeImage = styled.img`
  box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.1);
  grid-column: 2 / -2;
  width: 100%;

  @media (min-width: ${Breakpoints.md}) {
    grid-row: span 6;
    grid-column: 1 / 5;
    max-width: 221px;
    justify-self: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
    max-width: 256px;
  }
`

export const DataTypeIndicator = styled.div`
  display: flex;
  justify-content: center;
  color: var(--burnt-orange);

  margin-top: 32px;
  grid-column: 1 / -1;
  ${mobileTextStyles.MobileHeadingFourRegular}

  & > img {
    margin-right: 12px;
    width: 20px;
    height: 20px;
  }

  @media (min-width: ${Breakpoints.md}) {
    justify-content: left;
    grid-column: 6 / -1;
    ${tabletTextStyles.TabletSubHeading}
    margin-top: 0px;
    & > img {
      width: 16px;
      height: 16px;
    }
  }

  @media (min-width: ${Breakpoints.md}) {
    font-size: 14px;
    & > img {
      width: 20px;
      height: 20px;
    }
  }
`

export const Title = styled.h3`
  color: var(--slate);
  text-align: center;

  ${mobileTextStyles.MobileHeadingTwoSemiBold}
  grid-column: 1 / -1;
  margin-top: 12px;

  @media (min-width: ${Breakpoints.md}) {
    text-align: left;
    ${tabletTextStyles.TabletHeadingTwoBold}
    grid-column:  6 / -1;
    margin-top: 8px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingThreeBold}
  }
`

export const Body = styled.p`
  grid-column: -1 / 1;
  color: var(--body-text-grey);

  ${desktopTextStyles.BodyText16}
  text-align: center;
  margin-top: 24px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 6 / -1;
    margin-top: 16px;
    text-align: left;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
    grid-column: 6 / -3;
    margin-top: 24px;
  }
`

export const Properties = styled.h4`
  color: var(--slate);
  text-align: center;

  grid-column: 1 / -1;
  ${mobileTextStyles.MobileSubHeading}
  margin-top: 32px;

  @media (min-width: ${Breakpoints.md}) {
    text-align: left;
    grid-column: 6;
    margin-top: 24px;
    font-size: 14px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 32px;
    font-size: 16px;
  }
`
export const DividingLine = styled.div`
  background-color: var(--slate);
  height: 1px;
  opacity: 0.2;
  width: 100%;

  grid-column: 1 / -1;
  margin-top: 12px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 6 / -2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 6 / 9;
  }
`

export const PropertiesWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  ${mobileTextStyles.MobileSubHeading}
  color: var(--burnt-orange);
  grid-column: 1 / -1;
  font-weight: 300;
  margin-top: 10px;

  margin-bottom: 96px;

  & > li {
    margin: 6px 16px;
  }

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 6 / -1;
    font-size: 14px;
    justify-content: flex-start;
    margin-top: 0px;
    margin-bottom: 64px;

    & > li {
      margin: 14px 24px 0px 0px;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 6 / 10;
    font-size: 16px;

    margin-bottom: 96px;

    & > li {
      margin-top: 16px;
    }
  }
`
